// extracted by mini-css-extract-plugin
export default {"root":"user-email-cell-formatter_root__xo13L","emailContainer":"user-email-cell-formatter_emailContainer__v3mbU","email":"user-email-cell-formatter_email__K8wz0"};